import { render, staticRenderFns } from "./WorkTableChipsTooltipWrapper.vue?vue&type=template&id=b561b0ec"
import script from "./WorkTableChipsTooltipWrapper.vue?vue&type=script&lang=js"
export * from "./WorkTableChipsTooltipWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports